import { render, staticRenderFns } from "./expireDialog.vue?vue&type=template&id=012ed23e&scoped=true"
import script from "./expireDialog.vue?vue&type=script&lang=js"
export * from "./expireDialog.vue?vue&type=script&lang=js"
import style0 from "./expireDialog.vue?vue&type=style&index=0&id=012ed23e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ed23e",
  null
  
)

export default component.exports